import React, { useState } from 'react'
import { Row, Col, Input, Select, Tooltip } from 'antd'
import debounce from 'lodash/debounce'
import DiscountsTable from './DiscountsTable'
import { SearchOutlined } from '@ant-design/icons'
import { SelectDownArrowIcon, FilterIcon } from '@slerp/assets'
import { SelectPrefixWrapper } from '../Widgets'
import './styles.css'
import styled from '@emotion/styled'
import { DiscountFilter, DiscountType } from './types'

type DiscountProps = {
  type: DiscountType
}

interface tooltipDescription {
  [key: string]: string
}

const Codes = (props: DiscountProps) => {
  const { type } = props
  const [searchFilter, setSearchFilter] = useState('')
  const [discountFilter, setDiscountFilter] = useState<DiscountFilter>(
    DiscountFilter.ACTIVE
  )
  const triggerSearchFilter = (searchParam: string) => {
    setSearchFilter(searchParam)
  }
  const debouncedSetSearchFilter = debounce(triggerSearchFilter, 400)

  const tooltipDescription: tooltipDescription = {
    all: 'An overview of all discount codes ever created across all your stores.',
    active: 'Discount codes that are currently live.',
    scheduled:
      'Discount codes that are set to be live during a specific date range.',
    inactive: 'Discount codes that are not in use.'
  }

  return (
    <>
      <Row justify='space-between' className='_mt-16 _mb-32'>
        <Tooltip title={tooltipDescription[discountFilter]}>
          <Col className='_ml-8'>
            <SelectPrefixWrapper prefixicon={<FilterIcon />}>
              <Select
                data-testid='discount-table-filter'
                onChange={(target: DiscountFilter) => setDiscountFilter(target)}
                defaultValue={DiscountFilter.ACTIVE}
                suffixIcon={<SelectDownArrowIcon />}
              >
                <Select.Option
                  value={DiscountFilter.ALL}
                  data-testid='discount-table-filter-all'
                >
                  All
                </Select.Option>
                <Select.Option
                  value={DiscountFilter.ACTIVE}
                  data-testid='discount-table-filter-active'
                >
                  Active
                </Select.Option>
                <Select.Option
                  value={DiscountFilter.SCHEDULED}
                  data-testid='discount-table-filter-scheduled'
                >
                  Scheduled
                </Select.Option>
                <Select.Option
                  value={DiscountFilter.INACTIVE}
                  data-testid='discount-table-filter-inactive'
                >
                  Inactive
                </Select.Option>
              </Select>
            </SelectPrefixWrapper>
          </Col>
        </Tooltip>
        <Col>
          <StyledInput
            data-testid='discount-code-search-field'
            onChange={(e: any) => debouncedSetSearchFilter(e.target.value)}
            placeholder='Search discount code'
            prefix={<SearchOutlined />}
          />
        </Col>
      </Row>

      <div data-testid='inactive-tab-table'>
        <DiscountsTable
          trigger='code'
          filter={discountFilter}
          type={type}
          search={searchFilter}
        />
      </div>
    </>
  )
}

const StyledInput = styled(Input)`
  width: 280px;
`

export default Codes
